/* LUS · Article: table of contents, scrollspy, reading progress, copy link. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60);
  }

  function buildToc() {
    var body = document.querySelector('.ar-body');
    var box = document.querySelector('.ar-toc');
    if (!body || !box) return;

    var heads = [].slice.call(body.querySelectorAll('h2'));
    if (heads.length < 2) { box.remove(); return; }

    var list = document.createElement('ol');
    var seen = {};
    var links = [];

    heads.forEach(function (h) {
      var text = h.textContent.trim();
      if (!text) return;
      var id = h.id || slug(text) || 's';
      if (seen[id]) { id = id + '-' + (++seen[id]); } else { seen[id] = 1; }
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    box.appendChild(list);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id);
          });
        });
      }, { rootMargin: '-88px 0px -72% 0px', threshold: 0 });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  function progress() {
    var bar = document.querySelector('.ar-prog');
    var body = document.querySelector('.ar-body');
    if (!bar || !body) return;
    var tick = false;

    function update() {
      tick = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      var done = total > 0 ? (-r.top) / total : 0;
      bar.style.width = Math.max(0, Math.min(1, done)) * 100 + '%';
    }
    function onScroll() {
      if (tick) return;
      tick = true;
      requestAnimationFrame(update);
    }
    update();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
  }

  function copyLink() {
    var btn = document.querySelector('.ar-copy');
    if (!btn) return;
    var label = btn.querySelector('span');
    btn.addEventListener('click', function () {
      var url = location.href.split('#')[0];
      var done = function () {
        btn.classList.add('ok');
        if (label) label.textContent = btn.dataset.done || 'Link copied';
        setTimeout(function () {
          btn.classList.remove('ok');
          if (label) label.textContent = btn.dataset.idle || 'Copy link';
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () {});
      }
    });
  }

  ready(function () {
    buildToc();
    progress();
    copyLink();
  });
})();
